@if (alertSuccessShow) {
    <div id="bodyAlert" class="alert-panel alert-panel-container" [ngClass]="{ 'fade-in-right': alertSuccessShow }">
        <fuse-alert [type]="'success'">
            <span fuseAlertTitle>{{ 'label_action_success' | translate }}</span>
            <span [innerHTML]="alertSuccessMessage"></span>
        </fuse-alert>
    </div>
}

@if (alertInfoShow) {
    <div id="bodyAlert" class="alert-panel alert-panel-container" [ngClass]="{ 'fade-in-right': alertInfoShow }">
        <fuse-alert [type]="'info'">
            <span fuseAlertTitle>{{ alertInfoHeader }}</span>
            <span [innerHTML]="alertInfoMessage"></span>
        </fuse-alert>
    </div>
}

@if (alertHidden) {
    <div id="errorAlert">
        <div class="center-div alert-content">
            <div id="bodyAlert" class="c-alert" [ngClass]="alertHidden ? 'fade-in-left' : 'hidden'">
                <mat-icon
                    id="c-close"
                    class="white white-hover icon-size-5 hover:cursor-pointer"
                    (click)="closealertAlert()"
                    svgIcon="heroicons_outline:x"
                ></mat-icon>
                <fuse-alert [type]="'error'">
                    <span fuseAlertTitle>{{ alertHeader }}</span>
                    <span [innerHTML]="alertMessage"></span>
                    <span class="separator-line mt-1 mb-1 float-left w-100"></span>
                    <span class="text-sm float-left w-100">{{ alertFooter }}</span>
                </fuse-alert>
            </div>
        </div>
    </div>
}

@if (alertErrorShow) {
    <div id="bodyAlert" class="alert-panel alert-panel-container" [ngClass]="{ 'fade-in-right': alertErrorShow }">
        <fuse-alert [type]="'warning'">
            <span fuseAlertTitle>{{ alertHeader }}</span>
            <span [innerHTML]="alertErrorMessage"></span>
        </fuse-alert>
    </div>
}
